import { Grid, Typography } from '@mui/material';
import { LinkPanel } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { useClearRefinements } from 'react-instantsearch';
import { Link } from 'react-router-dom';

import { useSearchDomains } from '../../hooks/useSearchDomains/useSearchDomains.ts';
import { RouteId } from '~/routes';
import { useSearchDomainConfig } from '~/routes/Search/components/SearchDomainConfigProvider';

import { GridStyled } from './SearchEmpty.styled.tsx';

export const SearchEmpty = () => {
  const { searchDomains } = useSearchDomains();
  const { searchConfigByDomain } = useSearchDomainConfig();
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchDialog' });

  const { refine: clearRefinements } = useClearRefinements();
  clearRefinements();

  return (
    <>
      <Typography variant="subtitle1" sx={{ marginTop: 2, marginBottom: 3 }}>
        {t('searchEmpty.title')}
      </Typography>
      <Grid container spacing={3} direction="row" sx={{ flexGrow: 1 }}>
        {searchDomains.map((searchDomain) => {
          const { icon: Icon, title, description } = searchConfigByDomain(searchDomain);
          return (
            <GridStyled key={searchDomain} size={{ sm: 12, md: 4 }}>
              <LinkPanel
                icon={<Icon />}
                title={title}
                description={description}
                buttonComponent={Link}
                to={RouteId.searchDetail(searchDomain)}
              />
            </GridStyled>
          );
        })}
      </Grid>
    </>
  );
};
